import React from 'react'
import { useTranslation } from 'react-i18next'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const VideoSection = ({ videoUrl }) => {
    const { t } = useTranslation()

    return (
        <Block isRender={videoUrl}>
            <SectionCard icon="mdi:video" titleKey="video">
                <div className="video-container">
                    {videoUrl ? (
                        <iframe
                            className="video-iframe"
                            src={videoUrl}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Hospital Video"
                        />
                    ) : (
                        <div className="video-placeholder">
                            {t("no-video-available")}
                        </div>
                    )}
                </div>
            </SectionCard>
        </Block>
    )
}

export default VideoSection

